import React, { Component } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import store from "../../Store/index";

import "./DashBoard.css";
import Header from "../Common/Header/Header";
import TopNav from "../Common/TopNav/TopNav";
import SideNav from "../Common/SideNav/SideNav";
import moment from "moment";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import ModileResponsiveMenu from "../../Components/modileResponsiveMenu";
import { userAvatar } from "../../Constants/Constants";
import { getPOTallies, clearPOStates } from "../../Actions/POActions/POActions";
import {
  getInvoiceTallies,
  clearInvoiceStates,
} from "../../Actions/InvoiceActions/InvoiceActions";
import {
  getDocumentTallies,
  clearDocumentStates,
} from "../../Actions/DocumentActions/DocumentActions";
import {
  getSupplierTallies,
  clearSupplierStates,
  getSuppliersAndCache,
} from "../../Actions/SupplierActtions/SupplierActions";
import {
  getExpenseTallies,
  clearExpenseStates,
} from "../../Actions/ExpenseActions/ExpenseActions";
import {
  getTimecardTallies,
  clearTimecardStates,
} from "../../Actions/TimecardActions/TimecardActions";
import {
  setUserSettings,
  getAccountDetails,
  getDefaultValues,
  GetTransactionHistory,
  GetRecentActivity,
  getProductions,
  logInProduction,
  clearUserStates,
  clearStatesAfterLogout,
  GetUserTallies,
  getBasis
} from "../../Actions/UserActions/UserActions";
import {
  getJournalTallies,
  clearJournalStates,
} from "../../Actions/JournalActions/JournalActions";
import {
  getDistchangeTallies,
  clearDistChangesStates,
} from "../../Actions/DistChangesActions/DistChangesActions";
import { handleAPIErr } from "../../Utils/Helpers";
import { fetchChartCodes, getBankOptions } from "../../Actions/ChartActions/ChartActions";
import posthog from "posthog-js";

class DashBoard extends Component {
  constructor() {
    super();
    this.state = {
      isloading: false,
      welcome: true,
      ShowPOInsights: true,
      showTransactions: true,
      showActivity: true,
      poTallies: [],
      invoiceTallies: [],
      documentsTallies: [], //e.g Draft, Pending, Approved, etc
      supplierTallies: [], //e.g Draft, Pending, Approved, etc
      DistChangesTallies: [], //e.g Draft, Pending, Approved, etc
      expenseTallies: [], //e.g Draft, Pending, Approved, etc
      timecardTallies: [],
      journalTallies: [],
      userTallies:[]
    };
  }

  componentWillReceiveProps() {
    if (
      this.props.user.getAccountDetailsSuccess ||
      this.props.user.updateAccountDetailsSuccess
    ) {
      if (this.props.user.getAccountDetails.accountDetails) {
        //dashboard settings
        let dataArr = JSON.parse(
          localStorage.getItem("showOnDashboard") || "[]"
        );
        let email = this.props.user.getAccountDetails.accountDetails.email;
        let data = dataArr.find((f) => f.email === email);
        if (data) {
          this.setState({
            ShowPOInsights: data.POInsights,
            showTransactions: data.history,
            showActivity: data.activity,
          });
        }
        posthog.identify(email || "", {
          name: this.props.user.getAccountDetails.accountDetails?.name || "",
        });
        //end
      }
    }
  }

  async componentDidMount() {
    // await this.props.GetUserTallies();
    await this.dashBoardAPIs();

  }

  dashBoardAPIs = async (loginProdCheck) => {
    this.setState({ isLoading: true });

    let promises = [];

    /*loginProdCheck -> when user loin-prod on dasboard then call  getDefaultValues and all other tallies APIs to update 
    the state according to new login production*/
    if (loginProdCheck) {
      promises.push(this.props.getDefaultValues()); //getting users default values
    }

    let isSetngs = false; //to check if redux store contain user settings then dont call API again
    if (!this.props.user.setUserSettings.userDetails || loginProdCheck) {
      promises.push(this.props.setUserSettings());
    } else {
      isSetngs = true;
    }

    let isPOTal = false; //to check if redux store contain po tallies then dont call API again
    let isInvTal = false; //to check if redux store contain invoice tallies then dont call API again
    let isDocTal = false; //to check if redux store contain doc tallies then dont call API again
    let isSupTal = false; //to check if redux store contain doc tallies then dont call API again
    let isDIstTal = false; //to check if redux store contain doc tallies then dont call API again
    let isExpTal = false; //to check if redux store contain exp tallies then dont call API again
    let isTCTal = false; //to check if redux store contain timecard tallies then dont call API again
    let isJrnlTal = false; //to check if redux store contain journal tallies then dont call API again


    if (localStorage.getItem("blockPO") === "N" || localStorage.getItem("blockInvoice") === "N" || localStorage.getItem("blockDocuments") === "N" || localStorage.getItem("blockSupplier") === "Y" || localStorage.getItem("blockDistChange") === "N" || localStorage.getItem("blockExpense") === "N" || localStorage.getItem("blockTimecards") === "N" || localStorage.getItem("blockJournals") === "N"){
      promises.push(this.props.GetUserTallies())
      isPOTal = true;
      isInvTal = true;
      isDocTal = true;
      isSupTal = true;
      isDIstTal = true;
      isExpTal = true;
      isTCTal = true;
      isJrnlTal = true;
    }



    //if productions exists in redux store then dont call API again
    let productions = this.props.user.productions || [];
    if (productions.length === 0) {
      promises.push(this.props.getProductions()); //call api to get productions list
    }

    if (this.props.user.getTransactionHistory.length === 0 || loginProdCheck) {
      promises.push(this.props.GetTransactionHistory()); //call api to get transaction history
    }
    const cachedRequests = [
    getBasis().catch((error) => console.log('error while caching basis', error)),
    getBankOptions().catch((error) => console.log('error while caching bank options', error)),
    fetchChartCodes().catch((error) => { console.log('error while fetching chart codes', error) }),
  ];

  // As this is a heavy request, it is recommended to execute without awaiting. hope there is no reload done here
  getSuppliersAndCache(loginProdCheck).catch((error) => { console.log('error while getting suppliers', error) });

    promises.push(...cachedRequests);

    await Promise.all(promises);

    let userTallies;

    let poTallies = [];
    let invoiceTallies = [];
    let documentsTallies = [];
    let supplierTallies = [];
    let expenseTallies = [];
    let timecardTallies = [];
    let journalTallies = [];
    let DistChangesTallies = [];
    let opTypes = [];
    let userType = localStorage.getItem("userType");
    userType = userType ? userType.toLowerCase() : "";
    const talliesModule = { 
      orders: "Orders", 
      invoices: "Invoices", 
      documents: "Documents", 
      expenses: "Expenses", 
      journals: "Journals", 
      timecards: "Timecards", 
    };

    if (userType === "approver") {
      opTypes = ["approve", "hold", "pending", "declined", "approved", "all"];
    } else if (userType === "op/approver") {
      opTypes = ["draft", "approve", "hold", "pending", "declined", "approved", "all"];
    }
    else if (userType === "admin"){
      opTypes = ["draft", "pending", "declined", "approved", "all"];
    }
    else {
      //operator
      opTypes = ["draft", "pending", "declined", "approved", "all"];
    }
    if (this.props.user.getUserTalliesSuccess){
      userTallies = this.props.user.getUserTallies;
      this.setState(userTallies)
      if (opTypes && opTypes.length > 0) {
          // Orders module
          const orderIdx = userTallies.findIndex((ut) => ut.module === talliesModule.orders);
            if (orderIdx > -1) {
                opTypes.map(t => {
                  const obj = {
                    type: t,
                    count: userTallies[orderIdx][t],
                    percent: ""
                }
                poTallies.push(obj);
                });
            }   
            // Invoices module
            const invoicesIdx = userTallies.findIndex((ut) => ut.module === talliesModule.invoices);
              if (invoicesIdx > -1) {
                opTypes.map(t => {
                  const obj = {
                    type: t,
                    count: userTallies[invoicesIdx][t],
                    percent: ""
                  }
                  invoiceTallies.push(obj);
                });
              }
            // Documents module
            const documentsIdx = userTallies.findIndex((ut) => ut.module === talliesModule.documents);
              if (documentsIdx > -1) {
                opTypes.map(t => {
                  const obj = {
                    type: t,
                    count: userTallies[documentsIdx][t],
                    percent: ""
                  }
                  documentsTallies.push(obj);
                });
                }
            // Expense module
            const expensesIdx = userTallies.findIndex((ut) => ut.module === talliesModule.expenses);
              if (expensesIdx > -1) {
                opTypes.map(t => {
                  const obj = {
                    type: t,
                    count: userTallies[expensesIdx][t],
                    percent: ""
                  }
                  expenseTallies.push(obj);
                });
              }
            // Journal module
            const journalsIdx = userTallies.findIndex((ut) => ut.module === talliesModule.journals);
              if (journalsIdx > -1) {
                opTypes.map(t => {
                  const obj = {
                    type: t,
                    count: userTallies[journalsIdx][t],
                    percent: ""
                  }
                  journalTallies.push(obj);
                });
              }
            // Timecard module
             const timecardsIdx = userTallies.findIndex((ut) => ut.module === talliesModule.timecards);
              if (timecardsIdx > -1) {
                  opTypes.map(t => {
                    const obj = {
                      type: t,
                      count: userTallies[timecardsIdx][t],
                      percent: ""
                    }
                    timecardTallies.push(obj);
                  });
              }
      }
    }
    //success case of set user settings
    if (this.props.user.setUserSettingsSuccess || isSetngs) {
      //  toast.success(this.props.user.setUserSettingsSuccess)
    }

    //error case of set user settings
    if (this.props.user.setUserSettingsError) {
      handleAPIErr(this.props.user.setUserSettingsError, this.props);
    }

    //success case of get Productions
    if (this.props.user.getProductionsSuccess) {
      // toast.success(this.props.user.getProductionsSuccess);
    }
    //error case of get Productions
    if (this.props.user.getProductionsError) {
      handleAPIErr(this.props.user.getProductionsError, this.props);
    }
    //success case of get transaction history
    if (this.props.user.getTransactionHistorySuccess) {
      // toast.success(this.props.user.getTransactionHistorySuccess);
    }
    //error case of get transaction history
    if (this.props.user.getTransactionHistoryError) {
      handleAPIErr(this.props.user.getTransactionHistoryError, this.props);
    }

    //success case of get default vaues
    if (this.props.user.getDefaultValuesSuccess) {
      // toast.success(this.props.user.getDefaultValuesSuccess);
    }
    //error case of get default vaues
    if (this.props.user.getDefaultValuesError) {
      handleAPIErr(this.props.user.getDefaultValuesError, this.props);
    }

    this.props.clearPOStates();
    this.props.clearInvoiceStates();
    this.props.clearUserStates();
    this.props.clearJournalStates();
    this.props.clearSupplierStates();
    this.props.clearDistChangesStates();

    this.setState({
      isLoading: false,
      poTallies,
      invoiceTallies,
      documentsTallies,
      // supplierTallies, // have some issues from the back end sometimes coming as T & N but response not give correct result
      expenseTallies,
      timecardTallies,
      journalTallies,
      DistChangesTallies,
    });
    
    if (this.props.user.getRecentActivity.length === 0 || loginProdCheck) {
      await this.getRecentActivity(); //call api to get recent activities
    }
  };

  getRecentActivity = async () => {
    await this.props.GetRecentActivity(); //call api to get recent activities
    //success case of get recent activity
    if (this.props.user.getRecentActivitySuccess) {
      // toast.success(this.props.user.getRecentActivitySuccess);
    }
    //error case of get recent activity
    if (this.props.user.getRecentActivityError) {
      handleAPIErr(this.props.user.getRecentActivityError, this.props);
    }
    this.props.clearUserStates();
  };

  CloseNotify = (name) => {
    this.setState({ [name]: false });
  };

  //add new PO
  addNewPO = async () => {
    this.props.history.push("/new-purchase-order", {
      tran: "addNewPO",
    });
  };

  //Add New Invoice
  addNewInvoice = () => {
    this.props.history.push("/add-new-invoice", {
      type: "draft",
    });
  };

  //Add New Expense
  addNewExpense = () => {
    this.props.history.push("/expense-form", {
      tran: "insertExpense",
    });
  };

  //Add New Document
  addNewDocument = async () => {
    this.props.history.push("/documents-form", {
      tran: "addNewdocument",
    });
  };

  //Add New Supplier
  addNewSupplier = async () => {
    this.props.history.push("/new-supplier2", {
      tran: "addNewSupplier",
    });
  };

  //Add New Journal
  addNewJournal = async () => {
    this.props.history.push("/journal-form", {
      tran: "addNewJournal",
    });
  };

  //Add New Distchanges
  addNewDistChanges = async () => {
    this.props.history.push("/dist-changes-form", {
      tran: "addNewDistChanges",
    });
  };

  //Add New Timecard
  addNewTimecard = async () => {
    this.props.history.push("/add-edit-timecard", {
      tran: "newTimecard",
    });
  };

  //login production
  loginProduction = async (productionName) => {
    if (productionName) {
      this.setState({ isLoading: true });

      await this.props.logInProduction(productionName); //call api to login production

      //success case
      if (this.props.user.loginProductionSuccess) {
        store.dispatch({
          type: "CLEAR_STATES_WHEN_LOGIN_PRODUCTION",
        });

        localStorage.removeItem("getDefaultValues");
        localStorage.removeItem("loginProduction");
        localStorage.removeItem("userType");
        localStorage.removeItem("blockChart");
        localStorage.removeItem("blockPO");
        localStorage.removeItem("lockPONumber");
        localStorage.removeItem("blockInvoice");
        localStorage.removeItem("blockDocuments");
        localStorage.removeItem("blockExpense");
        localStorage.removeItem("blockPayments");
        localStorage.removeItem("blockTimecards");
        localStorage.removeItem("blockJournals");
        localStorage.removeItem("supplierApproval");
        localStorage.removeItem("blockSuppliers");
        localStorage.removeItem("usePageLoading");
        localStorage.removeItem("useTCPageLoading");
        localStorage.removeItem("blockDistChange");

        localStorage.setItem("loginProduction", productionName); //to show on dashboard

        let {
          userType,
          blockChart,
          blockPO,
          lockPONumber,
          blockInvoice,
          blockDocuments,
          blockExpense,
          blockPayments,
          blockJournals,
          blockDistChange,
          blockTimecards,
          supplierApproval,
          blockSuppliers,
          usePageLoading,
          useTCPageLoading,
          forceValidChartCodePO
        } = this.props.user.loginProductionData || "";

        userType = userType || "N";
        blockChart = blockChart || "N";
        blockPO = blockPO || "N";
        lockPONumber = lockPONumber || "N";
        blockInvoice = blockInvoice || "N";
        blockDocuments = blockDocuments || "N";
        blockExpense = blockExpense || "N";
        blockPayments = blockPayments || "N";
        blockJournals = blockJournals || "N";
        blockDistChange = blockDistChange || "N";
        blockTimecards = blockTimecards || "N";
        supplierApproval = supplierApproval || "N";
        blockSuppliers = blockSuppliers || "N";
        usePageLoading = usePageLoading || "N";
        useTCPageLoading = useTCPageLoading || "N";

        localStorage.setItem("userType", userType);
        localStorage.setItem("blockChart", blockChart); //if 'Y' then chart code + button will show otherwise not
        localStorage.setItem("blockPO", blockPO);
        localStorage.setItem("lockPONumber", lockPONumber); //if 'Y' then user not able to edit the PO Number in the PO Page (when PO Reference modal opens)
        localStorage.setItem("blockInvoice", blockInvoice);
        localStorage.setItem("blockDocuments", blockDocuments);
        localStorage.setItem("blockExpense", blockExpense);
        localStorage.setItem("blockPayments", blockPayments);
        localStorage.setItem("blockJournals", blockJournals);
        localStorage.setItem("blockDistChange", blockDistChange);
        localStorage.setItem("blockTimecards", blockTimecards);
        localStorage.setItem("supplierApproval", supplierApproval);
        localStorage.setItem("usePageLoading", usePageLoading);
        localStorage.setItem("useTCPageLoading", useTCPageLoading);
        localStorage.setItem("blockSuppliers", blockSuppliers); //if 'Y' then user not able to add/edit the supplier
        localStorage.setItem("forceValidChartCodePO", forceValidChartCodePO ?? '');

        this.getAccountDetails();
        sessionStorage.clear();
        await this.dashBoardAPIs(true);
      }
      //error case of
      if (this.props.user.loginProductionError) {
        handleAPIErr(this.props.user.loginProductionError, this.props);
      }
      this.props.clearUserStates();
      this.setState({ isLoading: false });
    } else {
      toast.error("Please Select A Production For Login!");
    }
  };

  getAccountDetails = async () => {
    await this.props.getAccountDetails();

    //success case of Get Account Details
    if (this.props.user.getAccountDetailsSuccess) {
      // toast.success(this.props.user.getAccountDetailsSuccess);
    }
    //error case of Get Account Details
    if (this.props.user.getAccountDetailsError) {
      handleAPIErr(this.props.user.getAccountDetailsError, this.props);
    }
    this.props.clearUserStates();
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  handleTallies = async (type, page) => {

    if (page === "orders") {
      this.props.history.push("/order", {
        dashboard: true,
        tallType: this.capitalizeFirstLetter(type),
      });
    } else if (page === "invoices") {
      this.props.history.push("/invoice", {
        dashboard: true,
        tallType: this.capitalizeFirstLetter(type),
      });
    } else if (page === "documents") {
      this.props.history.push("/documents", {
        dashboard: true,
        tallType:this.capitalizeFirstLetter(type),
      });
    } else if (page === "suppliers") {
      this.props.history.push("/suppliers", {
        dashboard: true,
        tallType: this.capitalizeFirstLetter(type),
      });
    } else if (page === "journals") {
      this.props.history.push("/journals", {
        dashboard: true,
        tallType: type,
      });
    } else if (page === "distchanges") {
      this.props.history.push("/dist-changes", {
        dashboard: true,
        tallType: this.capitalizeFirstLetter(type),
      });
    } else if (page === "timecard") {
      this.props.history.push("/timecards", {
        dashboard: true,
        tallType: this.capitalizeFirstLetter(type),
      });
    } else {
      this.props.history.push("/expenses", {
        dashboard: true,
        tallType: this.capitalizeFirstLetter(type),
      });
    }
  };

  render() {
    let blockPO = localStorage.getItem("blockPO") || "N";
    let blockInvoice = localStorage.getItem("blockInvoice") || "N";
    let blockDocuments = localStorage.getItem("blockDocuments") || "N";
    let blockSuppliers = localStorage.getItem("blockSuppliers") || "N";
    let blockExpense = localStorage.getItem("blockExpense") || "N";
    let blockJournals = localStorage.getItem("blockJournals") || "N";
    let blockDistChange = localStorage.getItem("blockDistChange") || "N";
    let blockTimecards = localStorage.getItem("blockTimecards") || "N";

    let {
      poTallies,
      invoiceTallies,
      expenseTallies,
      documentsTallies,
      supplierTallies,
      journalTallies,
      timecardTallies,
      DistChangesTallies,
    } = this.state;
    return (
      <>
        <div className="dashboard">
          {this.state.isLoading ? <div className="se-pre-con"></div> : ""}

          {/* top nav bar */}
          <Header
            props={this.props}
            company={true}
            loginProduction={this.loginProduction}
            loginProductionSuccess={this.props.user.loginProductionSuccess}
            getRecentActivity={this.getRecentActivity}
            dashboard={true}
          />
          {/* end */}

          {/* body part */}

          <div className="dashboard_body_content">
            {/* top Nav menu*/}
            <TopNav />
            {/* end */}

            {/* side nav menu */}
            <SideNav />
            {/* end */}

            <section id="contents">
              <div className="body_content">
                {this.state.welcome ? (
                  <div className="welcome">
                    <div className="containr-fluid">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="content">
                            <img
                              src="images/white-close.png"
                              onClick={() => this.CloseNotify("welcome")}
                              className="white_close"
                              alt="close"
                            />
                            <h2>WELCOME TO DIGITAL PAPER FLOW</h2>
                            <p>
                              Hello! Let's get started with Digital Paper Flow.
                              This is your dashboard to quickly show you recent
                              activity and a summary of orders and invoices.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <section className="statistics">
                  <div className="containr-fluid">
                    <div className="row">
                      {this.state.ShowPOInsights ? (
                        <div className="col-12">
                          <img
                            src="images/gray-close.png"
                            onClick={() => this.CloseNotify("ShowPOInsights")}
                            className="gray_close xs-position"
                            alt="close"
                          />
                          <div className="table-responsive home_table">
                            <table className="table home_stat_table">
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  {this.state.poTallies.map((pt, i) => {
                                    return (
                                      <th key={i} scope="col">
                                        {this.capitalizeFirstLetter(pt.type)}
                                      </th>
                                    );
                                  })}
                                </tr>
                              </thead>
                              <tbody>

                              {
                                poTallies.length > 0 ?
                                  <tr>
                                    <th scope="row">Orders</th>
                                    {poTallies.map((pt, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              pt.type,
                                              "orders"
                                            )
                                          }
                                        >
                                          <span> {pt.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                  :
                                  null
                              }
                              {
                                invoiceTallies.length > 0?
                                  <tr>
                                    <th scope="row">Invoices</th>
                                    {invoiceTallies.map((it, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              it.type,
                                              "invoices"
                                            )
                                          }
                                        >
                                          <span> {it.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                  : null
                              }
                              {
                                expenseTallies.length > 0?
                                  <tr>
                                    <th scope="row">Expenses</th>
                                    {expenseTallies.map((et, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              et.type,
                                              "expenses"
                                            )
                                          }
                                        >
                                          <span> {et.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                  : null
                              }
                              {
                                documentsTallies.length > 0?
                                  <tr>
                                    <th scope="row">Documents</th>
                                    {documentsTallies.map((dt, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              dt.type,
                                              "documents"
                                            )
                                          }
                                        >
                                          <span> {dt.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                  :
                                  null
                              }
                              {
                                supplierTallies.length > 0?
                                  <tr>
                                    <th scope="row">Suppliers</th>
                                    {supplierTallies.map((dt, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              dt.type,
                                              "suppliers"
                                            )
                                          }
                                        >
                                          <span> {dt.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr>: null
                              }
                              {
                                journalTallies.length > 0?
                                  <tr>
                                    <th scope="row">Journals</th>
                                    {journalTallies.map((jr, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              jr.type,
                                              "journals"
                                            )
                                          }
                                        >
                                          <span> {jr.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr>: null
                              }
                              {
                                DistChangesTallies.length > 0?
                                  <tr>
                                    <th scope="row">DistChanges</th>
                                    {DistChangesTallies.map((dt, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              dt.type,
                                              "distchanges"
                                            )
                                          }
                                        >
                                          <span> {dt.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr> : null
                              }
                              {
                                timecardTallies.length > 0?
                                  <tr>
                                    <th scope="row">Timecards</th>
                                    {timecardTallies.map((tc, i) => {
                                      return (
                                        <td
                                          className="cursorPointer"
                                          key={i}
                                          onClick={() =>
                                            this.handleTallies(
                                              tc.type,
                                              "timecard"
                                            )
                                          }
                                        >
                                          <span> {tc.count}</span>
                                        </td>
                                      );
                                    })}
                                  </tr> : null
                              }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="col-12">
                        <div className="row">
                          {/* Transactions History */}
                          {this.state.showTransactions ? (
                            <div className="col-xl-7">
                              <div className="forgot_body recent_act">
                                <img
                                  src="images/gray-close.png"
                                  onClick={() =>
                                    this.CloseNotify("showTransactions")
                                  }
                                  className="gray_close"
                                  alt="close"
                                />
                                <div className="row">
                                  <div className="col-12 mb-2">
                                    <h4 className="recent_actives">
                                      Transactions History
                                    </h4>
                                  </div>
                                  {this.props.user.getTransactionHistory.map(
                                    (t, i) => {
                                      return (
                                        <div key={i} className="col-md-12">
                                          <div className=" d-flex activity_item_main comments_main recent_active_main tans_history purpal">
                                            <div className="row w-100">
                                              <div className="col-md-2">
                                                <div className="activity_9">
                                                  <p className="trans_price ">
                                                    {t.amount.toFixed(2)}
                                                  </p>
                                                  <p>
                                                    <span className="trans_date_time">
                                                      {/* Today{" "} */}
                                                      {moment
                                                        .unix(t.date)
                                                        .format("DD MMM YYYY")
                                                        .toUpperCase()}
                                                    </span>
                                                    <span className="trans_date_time">
                                                      {moment
                                                        .unix(t.time)
                                                        .format("hh:mm a")}
                                                    </span>
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="col-md-10">
                                                <div className="  p-all-0">
                                                  <div className="row p-all-0">
                                                    <div className="col-md-4  pl-0">
                                                      <div className="activity_9 p-0">
                                                        <h6 className="activity_9_h5 p-0">
                                                          {t.approver}
                                                        </h6>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                      <div className="activity_9">
                                                        <p className="mb-0 custom-para">
                                                          {t.status}
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                      <div className="activity_9">
                                                        <p>{t.supplierName}</p>
                                                      </div>
                                                    </div>

                                                    <div className="col-12 p-0 border-top">
                                                      <div className="activity_9 p-0">
                                                        <p>
                                                          {t.description}
                                                          {/* <br />
                                                    COLOURED PAPER */}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {/* end */}
                          {/* Recent Activity */}
                          {this.state.showActivity ? (
                            <div className="col-xl-5 pl-xl-0">
                              <div className="forgot_body recent_act pb-md-3">
                                <img
                                  src="images/gray-close.png"
                                  onClick={() =>
                                    this.CloseNotify("showActivity")
                                  }
                                  className="gray_close"
                                  alt="close"
                                />
                                <div className="row">
                                  <div className="col-12 mb-2">
                                    <h4 className="recent_actives">
                                      Recent Activity
                                    </h4>
                                  </div>
                                  {this.props.user.getRecentActivity.map(
                                    (a, i) => {
                                      return (
                                        <div key={i} className="col-md-12">
                                          <div className="activity_item_main custom-activity comments_main recent_active_main">
                                            <div className="row w-100 m-0">
                                              <div className="col-auto mm_avator_img">
                                                <div className="recent_active_pic">
                                                  <img
                                                    src={
                                                      a.userAvatar
                                                        ? "data:image/png;base64," +
                                                          a.userAvatar
                                                        : userAvatar
                                                    }
                                                    className="import_icon img-fluid float-left circle-image"
                                                    alt="user"
                                                  />
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  width: "calc(100% - 53px)",
                                                  justifyContent:
                                                    "space-between",
                                                  display: "flex",
                                                }}
                                              >
                                                <div className="col p-md-0">
                                                  <div className="activity_9 custom-activities p-0">
                                                    <h6 className="activity_9_h5 p-0 mb-0">
                                                      {a.userName}
                                                    </h6>
                                                    <p className="paragraphText">
                                                      {a.action}
                                                    </p>
                                                  </div>
                                                </div>
                                                <div className="col-sm-auto p-0 text-right d-flex align-items-center">
                                                  <div className="activity_3 ">
                                                    <p>
                                                      {moment
                                                        .unix(a.actionDate)

                                                        .format("DD MMM YYYY")
                                                        .toUpperCase()}{" "}
                                                      {moment
                                                        .unix(a.actionTime)
                                                        .format("hh:mm a")}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {/* end */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </section>
            <div className="sticky_drop mm_sticky_menu">
              <Dropdown
                alignRight={true}
                drop="up"
                className="dash analysis-card-dropdwn drop__dash--clickbuton"
              >
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img
                    src="images/add-icon.png"
                    className="img-fluid add_icon_img"
                    alt="add icon"
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {blockInvoice === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewInvoice}>
                      <a href="#">New Invoice</a>
                    </Dropdown.Item>
                  )}
                  {blockPO === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewPO}>
                      <a href="#">New PO</a>
                    </Dropdown.Item>
                  )}
                  {blockSuppliers === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewSupplier}>
                      <a href="#">New Supplier</a>
                    </Dropdown.Item>
                  )}
                  {blockExpense === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewExpense}>
                      <a href="#">New Expense</a>
                    </Dropdown.Item>
                  )}
                  {blockDocuments === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewDocument}>
                      <a href="#">New Document</a>
                    </Dropdown.Item>
                  )}
                  {blockJournals === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewJournal}>
                      <a href="#">New Journal</a>
                    </Dropdown.Item>
                  )}
                  {blockDistChange === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewDistChanges}>
                      <a href="#">New Distchanges</a>
                    </Dropdown.Item>
                  )}
                  {blockTimecards === "Y" ? (
                    ""
                  ) : (
                    <Dropdown.Item onClick={this.addNewTimecard}>
                      <a href="#">New Timecard</a>
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          {/* end */}
          <ModileResponsiveMenu props={this.props} active="dashboard" />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  poData: state.poData,
  invoice: state.invoice,
  chart: state.chart,
  document: state.document,
  supplier: state.supplier,
  expenseData: state.expense,
  journal: state.journal,
  timecard: state.timecard,
  distchange: state.distchange,
});

export default connect(mapStateToProps, {
  setUserSettings,
  getAccountDetails,
  logInProduction,
  getDefaultValues,
  getPOTallies,
  clearPOStates,
  getInvoiceTallies,
  clearInvoiceStates,
  getProductions,
  GetTransactionHistory,
  GetRecentActivity,
  getDocumentTallies,
  clearDocumentStates,
  getSupplierTallies,
  clearSupplierStates,
  getExpenseTallies,
  getJournalTallies,
  getTimecardTallies,
  clearTimecardStates,
  clearJournalStates,
  clearExpenseStates,
  clearUserStates,
  clearStatesAfterLogout,
  getDistchangeTallies,
  clearDistChangesStates,
  GetUserTallies
})(DashBoard);
